import { render, staticRenderFns } from "./audience.targetWithChipsAutocomplete.vue?vue&type=template&id=d74f94cc&lang=pug"
import script from "./audience.targetWithChipsAutocomplete.vue?vue&type=script&lang=js"
export * from "./audience.targetWithChipsAutocomplete.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports